<template>
  <section id="advertisingPolicy" class="cookiePolicy section-show" style="height: auto!important;">
    <div class="container">

      <div>
        <h2>Согласие на получение рекламной и/или информационной рассылки</h2>

        <p>
          Настоящим, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, я, в
          соответствии со ст. 18 Федерального закона «О рекламе», даю Индивидуальному предпринимателю Самигуллину
          Евгению Марселевичу, ИНН 745208585592, ОГРНИП 317745600168025, адрес: 454071, Челябинская Область, Челябинск
          Город, Правдухина Улица, дом д. 14, кв./офис кв. 4 (далее – «Оператор») свое согласие:
        </p>

        <ul>
          <li>
            1. На направление мне на указанные мной на сайте https://app.zavbus.ru/ контактные данные (номер телефона
            и/или электронную почту) сообщений в информационных, рекламно-информационных целях об услугах (сервисах)
            Оператора, а именно: рассылок о мероприятиях, контенте, акциях и др. информационного и рекламного
            характера
            в виде sms-сообщений, и/или электронных писем, и/или сообщений в мессенджерах, и/или push-уведомлений,
            и/или
            посредством телефонных звонков.
          </li>
          <li> 2. Настоящее согласие является подписанным мной электронной подписью путем проставления отметки
            («галочки») и/или нажатие кнопки рядом с надписью «Согласен получать информационные и/или рекламные
            письма» (или иного сообщения, идентичного по смыслу), и/или путем заполнения и отправки форм на сайте
            https://app.zavbus.ru/, где размещена соответствующая кнопка/надпись/форма.
          </li>
          <li> 3. Согласие на рекламную рассылку считается предоставленным в момент нажатия кнопки, подтверждающей
            отправку формы, проставления соответствующей галочки, что является достаточной формой согласия и позволяет
            подтвердить сторонам факт получения такого согласия, при этом иных доказательств для дополнительного
            подтверждения моего свободного волеизъявления не потребуется.
          </li>
          <li> 4. Отписка от e-mail-рассылок возможна путем перехода по гипертекстовой ссылке «Отписаться» (или с иным
            текстом — аналогичным по смыслу) в тексте e-mail-рассылки, что обеспечивает автоматическую отписку.
          </li>
          <li> 5. Согласие может быть отозвано полностью или частично в любой момент путем направления в адрес
            Оператора заявления об отзыве Согласия на e-mail-адрес zavbus@mail.ru, либо на юридический адрес
            Оператора.
          </li>
          <li> 6. Заявление об отзыве Согласия может быть составлено в свободной форме с указанием в нем следующих
            данных: фамилию, имя, номер телефона, адрес электронной почты, позволяющие идентифицировать заявителя.
            Качество изображения должно быть достаточным для четкого и однозначного понимания текста заявления.
          </li>
          <li> 7. Согласие вступает в силу с даты его предоставления и действует до момента его отзыва.</li>
          <li> 8. Я также подтверждаю, что предоставленные мною в адрес Оператора номер телефона и/или адрес
            электронной почты принадлежат мне, а направляемая на них рекламная информация предназначена только для
            меня и не будет получаться третьими лицами, не давшими Оператору предварительного согласия на получение
            рекламной информации.
          </li>
        </ul>

        <p>
          Реквизиты Оператора:
          ИП Самигуллин Евгений Марселевич
          454071, Челябинская Область, Челябинск Город, Правдухина Улица, дом д. 14, кв./офис кв. 4,
          ИНН 745208585592, ОГРНИП 317745600168025
          Тел: +7 (351) 750-72-87, E-mail: zavbus@mail.ru
        </p>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'CookiePolicyPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
</script>

<style scoped>


</style>
